import { Button, Tab } from '@material-ui/core';
import { Settings } from '@material-ui/icons';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { getInfosAccount, getContractStudentData } from '@webapps/business';
import { useAuth, useQuery, useToast } from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useState } from 'react';
import Account from 'components/AccountSettings/Account';
import StudentContract from 'components/AccountSettings/StudentContract';

const SettingsSchool = () => {
  const {
    classes,
    css,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const [value, setValue] = useState('1');
  const { addToast } = useToast();

  const { idUser } = useAuth();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { data: accountInfos = [], refetch: refetchAccountInfo } = useQuery(
    getInfosAccount,
    {
      key: 'accountInfos',
      variables: { id: idUser },
    }
  );

  const { data: infosContract = {}, refetch: refetchInfosContract } = useQuery(
    getContractStudentData,
    {
      key: ['infosContract', idUser],
      variables: { id: idUser },
    }
  );

  return (
    <div className={global.container}>
      <div className={classes.paper} square>
        <TabContext value={value}>
          <div>
            <TabPanel className={css({ padding: spacing(0) })} value="1">
              <Account
                accountInfos={accountInfos}
                refetchAccountInfo={refetchAccountInfo}
              />
              <StudentContract infosContract={infosContract} refetchInfosContract={refetchInfosContract} />
            </TabPanel>
            <TabPanel className={css({ padding: spacing(0) })} value="2" >

            </TabPanel>
          </div>
        </TabContext>
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  paper: {
    flex: '1 1 0px',
    borderRadius: 10,
    '@media only screen and (max-width:768px)': {
      marginTop: spacing(3),
      paddingTop: 0,
    },
  },
  containerTabPanel: {
    margin: 0,
    padding: 0,
  },
});

export default SettingsSchool;
